/**
 * サイト内で使われるメインのカラーを定義（この色をtailwind.config.jsの`primary-◯◯`に定義している）
 * なのでメインのカラーは必ずこの変数を参照する
 * - class名：`text-primary-◯◯`
 * - CSSファイル内：`color: theme('colors.primary.50');`のようにプロパティ値を指定
 * - ライブラリなどでカラーコードの参照が必要な時：`brandColors.50`のように指定
 */

export const brandColors = {
  50: '#E8EFFC',
  200: '#88B6F1',
  400: '#5B8CEC',
  500: '#2B5CDD',
  700: '#2B3753',
  800: '#222C42',
  // デバッグ用（グリーンベースのカラー）
  // 50: '#E8FCE9',
  // 200: '#8DF188',
  // 400: '#6EEC5B',
  // 500: '#37DD2B',
  // 700: '#34532B',
  // 800: '#224224',
};
